import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  headObject: {
    dateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(), 
    dateTo: new Date().toISOString(),
    location: 'ALQ-Hyper',
    status: 'All',
    countStatus: 'All',
    varianceStatus: 'All',
    finalPosting: 'All',
    gridData: [],
  },
  countingSummary : [],
  countingDetail : []
};

const   SliceCyclicPhysicalStockCounting= createSlice({
  name: 'SliceCyclicPhysicalStockCounting',
  initialState,
  reducers: {
    setHeadObject(state, action) {
      state.headObject = { ...state.headObject, ...action.payload };
    },
    addGridRow(state, action) {
      state.headObject.gridData.push(action.payload);
    },
    setCountingSummary(state,action) {
     
      state.countingSummary = action.payload
    },
    setCountingDetail(state,action) {
     
      state.countingDetail = action.payload
    }
  },
});

export const { setHeadObject, addGridRow,setCountingSummary,setCountingDetail } = SliceCyclicPhysicalStockCounting.actions;
export default SliceCyclicPhysicalStockCounting.reducer;
